import { PerformanceReviewEditReviewersModal } from "@/pages/talent/performance-reviews/view/widgets/PerformanceReviewEditReviewersModal.tsx";
import {
  ApiPerformanceReviewReviewerType,
  PerformanceReviewReviewerTypeItems,
} from "@/types/performance-review.types.ts";
import { Button, Modal, ModalProps, Select, Stack, useModals } from "@skailer-com/uikit";
import { useState } from "react";
import { useTranslation } from "react-i18next";

export interface PerformanceReviewSelectReviewTypeModalProps extends ModalProps {
  performanceReviewId: number;
  employeeId: number;
  reviewerTypes: ApiPerformanceReviewReviewerType[];
  withStatuses?: boolean;
}

export function PerformanceReviewSelectReviewTypeModal({
  performanceReviewId,
  employeeId,
  reviewerTypes,
  withStatuses = true,
  ...props
}: PerformanceReviewSelectReviewTypeModalProps) {
  const { t } = useTranslation();
  const { id } = { ...props };
  const { close, openModal } = useModals();

  const [selectedTypeId, setSelectedTypeId] = useState<number | undefined>(reviewerTypes[0]?.id);

  const options = reviewerTypes.map((rt) => ({
    id: rt.id,
    title:
      PerformanceReviewReviewerTypeItems().find((item) => item.id === rt.type)?.title ??
      rt.title ??
      t("common:no_title"),
  }));

  const handleSelect = () => {
    if (!selectedTypeId) return;

    close(id);
    openModal(PerformanceReviewEditReviewersModal, {
      performanceReviewId,
      employeeId,
      reviewerTypeId: selectedTypeId,
      withStatuses,
    });
  };

  return (
    <Modal
      title={t("performance_review:select_group")}
      variant={"middle"}
      layout={"base"}
      size={"md"}
      withCloser
      {...props}
    >
      <Stack gap={"2xl"}>
        <Select
          label={t("performance_review:group")}
          emptyTitle={t("common:select")}
          value={selectedTypeId}
          options={options}
          onChange={(value) => setSelectedTypeId(value as number)}
        />

        <Button type={"submit"} size={"lg"} onClick={handleSelect} disabled={!selectedTypeId}>
          {t("common:select")}
        </Button>
      </Stack>
    </Modal>
  );
}
